import moment from 'moment';

const NOTTags = (doc, data, clinica, item, index, typeNot) => {
    var NOT = doc.createElement("NOT");

    //Nota de la Factura
    if (typeNot == "SALUD") {
        var NOT_1 = doc.createElement("NOT_1");
        NOT_1.innerHTML = createHealthNOTTagSTRING(doc, data, clinica, item, index);
        NOT.appendChild(NOT_1);
    }
    else {
        var NOT_1 = doc.createElement("NOT_1");
        NOT_1.innerHTML = data.nota;
        NOT.appendChild(NOT_1);
    }

    return NOT;
}

const createHealthNOTTagSTRING = (doc, data, clinica, item, index) => {

    /*
    Ejemplo Factura Tech:

    (Numero:1|Paciente:carlos vazquez|FechaNacimiento:|TipoIdentificacion:identificacion|NumeroIdentificacion:123|Direccion:
        |Telefono:12356788|TipoAfiliado:Beneficiario|FechaIngreso:2020-11-21|FechaEgreso:2020-11-30
        |Autorizacion:auth|Orden:orden|Aseguradora:aseguradora|Historia:historia!|Concepto:concepto|CUM:cum|CUP:cup)
        
    */

    let stringHealth = "";
    stringHealth = stringHealth + `Numero:${parseInt(index + 1)}|`;
    stringHealth = stringHealth + `Paciente:${item.nombre_paciente}|`;
    stringHealth = stringHealth + `FechaNacimiento:${moment(item.fec_nacimiento_paciente).format("YYYY-MM-DD")}|`;
    stringHealth = stringHealth + `TipoIdentificacion:${item.tip_documento_paciente}|`;
    stringHealth = stringHealth + `NumeroIdentificacion:${item.num_documento_paciente}|`;
    stringHealth = stringHealth + `Direccion:${item.direccion_paciente.direccion}|`;
    stringHealth = stringHealth + `Telefono:${item.celular_paciente}|`;
    stringHealth = stringHealth + `TipoAfiliado:${data.facturado.tipo_documento != "NIT" ? "Particular" : "Beneficiario"}|`;
    stringHealth = stringHealth + `FechaIngreso:${moment(item.fecha_admision).format("YYYY-MM-DD")}|`;
    stringHealth = stringHealth + `FechaEngreso:${moment(item.fecha_admision).format("YYYY-MM-DD")}|`;
    stringHealth = stringHealth + `Autorizacion:${item.codigo_autorizacion != null ? item.codigo_autorizacion : ""}|`;
    stringHealth = stringHealth + `Orden:${item.id_admision}|`;
    stringHealth = stringHealth + `Aseguradora:${data.facturado.tipo_documento != "NIT" ? "" : data.facturado.nombre_adquiriente}|`;
    stringHealth = stringHealth + `Historia:${item.num_documento_paciente}|`;
    stringHealth = stringHealth + `Concepto:${item.servicios.servicios[0].nombre}|`;
    //stringHealth = stringHealth + `CUM:|`;
    stringHealth = stringHealth + `CUP:${item.servicios.servicios[0].codigo}`;
    return stringHealth;
}

export default NOTTags;